/**
 * Created by james on 6/5/14.
 */
"use strict";
// ---------------------------------------------------
// Dependencies

var endpoints = require('dibs-endpoints');
var ServiceMethod = require('../../models/logistics/ServiceMethod');

// ---------------------------------------------------
// Module Definition

module.exports = {
    KEY: 'SELLER_SERVICE_METHOD_DISPLAY_MAP',
    url: endpoints.referenceSet(),
    makeRequest: function () {
        return ServiceMethod.fetchSellerMethodDisplayCollection();
    },
    getDataOnResolve: function () {
        return ServiceMethod.getSellerMethodDisplayCollection();
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/async-dp-configs/serviceMethodDisplay.js
// module id = 2628
// module chunks = 64